<script>
  import Table from '@components/table'
  import Button from '@components/buttons/button.svelte'
  import BoxedText from '@components/general/boxed-text.svelte'
  import Text from '@components/general/text.svelte'
  import { Pencil, CirclePlus, Trash2, Users } from 'lucide-svelte'
  import { router } from '@inertiajs/svelte'
  import { formatDateText } from '@lib/utils/date'

  let { programme, onEdit, onCreate } = $props()

  function statusVariant(offer) {
    if (!offer.active) return "default"
    if (offer.open) return "success"
    return "warning"
  }

  function statusLabel(offer) {
    if (!offer.active) return "Inactive"
    if (offer.open) return "Open"
    return "Upcoming"
  }

  function handleDelete(offer) {
    if (!window.confirm(`Are you sure you want to delete ${offer.name}?`)) return
    router.delete(`/admin/programmes/${programme.id}/offers/${offer.id}`)
  }
</script>

<div>
  <div class="flex items-center justify-between mb-4">
    <Text variant="title" as="h2" text="Offers" class="text-xl" />
    <Button text="New offer" Icon={CirclePlus} onclick={onCreate} />
  </div>

  <Table.Root empty={!programme.offers?.length} emptyMessage="No offers yet. Create one to get started." emptyClass="h-[300px]">
    <Table.Head>
      <Table.Header width="30%">Name</Table.Header>
      <Table.Header width="12%">Price</Table.Header>
      <Table.Header width="20%">Date range</Table.Header>
      <Table.Header width="10%" align="center">Members</Table.Header>
      <Table.Header width="10%" align="center">Status</Table.Header>
    </Table.Head>

    <Table.Body>
      {#each programme.offers as offer (offer.id)}
        <Table.Row>
          <Table.Cell width="30%">
            <div class="flex items-center gap-2 group">
              <span class="font-medium">{offer.name}</span>
              <Button variant="naked" Icon={Pencil} hint="Edit" class="text-gray-400 hover:text-gray-700 opacity-0 group-hover:opacity-100 transition-opacity" iconProps={{ size: 12 }} onclick={() => onEdit(offer)} />
              <Button variant="naked" Icon={Trash2} hint="Delete" class="text-gray-400 hover:text-gray-700 opacity-0 group-hover:opacity-100 transition-opacity" iconProps={{ size: 12 }} onclick={() => handleDelete(offer)} />
            </div>
            {#if offer.entitlement_ends_on}
              <span class="text-xs text-gray-400">Entitlement ends {formatDateText(offer.entitlement_ends_on)}</span>
            {/if}
          </Table.Cell>
          <Table.Cell width="12%">{offer.display_price}</Table.Cell>
          <Table.Cell width="20%">
            {#if offer.opens_on || offer.closes_on}
              <span class="text-sm">
                {offer.opens_on ? formatDateText(offer.opens_on) : '—'}
                →
                {offer.closes_on ? formatDateText(offer.closes_on) : '—'}
              </span>
            {:else}
              <span class="text-gray-300">Always open</span>
            {/if}
          </Table.Cell>
          <Table.Cell width="10%" align="center">
            {#if offer.memberships_count > 0}
              <span class="inline-flex items-center gap-1 text-xs text-gray-600">
                <Users size={12} />
                {offer.memberships_count}
              </span>
            {:else}
              <span class="text-gray-300">—</span>
            {/if}
          </Table.Cell>
          <Table.Cell width="10%" align="center">
            <BoxedText variant={statusVariant(offer)} size="xs" text={statusLabel(offer)} />
          </Table.Cell>
        </Table.Row>
      {/each}
    </Table.Body>
  </Table.Root>
</div>